import PropTypes from 'prop-types';

function MMPantryActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11299)">
                <path
                    d="M8.05011 13.907C7.45693 13.6864 6.82584 13.5858 6.19347 13.6111C5.5611 13.6364 4.94006 13.7871 4.36639 14.0543C3.53805 14.4844 2.28757 15.3685 2.53847 15.7548C2.78936 16.1411 4.0916 16.3243 3.65752 17.3199C3.22344 18.3155 3.65752 18.6978 4.35046 18.9129C4.63709 18.9917 4.88283 19.1769 5.03751 19.4308C5.19219 19.6847 5.24415 19.988 5.18278 20.2788C5.0195 20.7687 5.29031 22.0351 6.19033 22.0948C7.09035 22.1546 7.72356 23.186 7.7594 23.6878C7.79524 24.1896 7.9386 24.7511 8.61163 24.8467C9.28466 24.9422 11.8175 25.0139 11.8334 20.6293C11.8334 17.0451 15.0193 18.3474 15.8636 18.8053C16.7079 19.2633 19.6907 19.5142 20.531 17.8376C21.3712 16.161 19.3721 16.5752 19.2128 16.0177C19.0535 15.4601 20.061 14.9583 19.7544 14.1897C19.4477 13.4211 18.5597 13.9428 18.3327 12.9671C18.1057 11.9915 19.0575 10.7848 18.0579 10.5777C17.0583 10.3706 16.676 10.6773 16.3335 10.1795C15.991 9.68166 16.1742 8.89315 15.537 8.41128C14.8998 7.92941 12.3073 9.12413 11.8891 11.2786C11.471 13.4331 11.9688 14.4207 10.9493 14.8628C9.92981 15.3048 9.58334 14.4207 8.05011 13.907Z"
                    fill="#F2D79A"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M8.40057 17.4035C8.40057 17.4035 8.67138 16.149 12.0445 16.5871C15.5928 17.045 15.7999 15.8384 15.7999 15.8384"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5574 13.9066C14.5574 13.9066 13.3627 13.4725 11.941 16.5629C10.4516 19.8205 9.32056 19.3506 9.32056 19.3506"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.1298 9.79682L16.7755 1.99928C16.473 1.67777 16.0991 1.432 15.684 1.28187C15.2689 1.13173 14.8242 1.08145 14.3861 1.1351C12.7174 1.38599 11.6183 3.28161 11.9289 5.36839C12.0014 5.955 12.198 6.51945 12.5056 7.02415C12.8132 7.52886 13.2248 7.96224 13.713 8.29546V8.29546L24.2744 16.2603C24.5707 16.5493 24.9282 16.768 25.3204 16.9004C25.7126 17.0327 26.1295 17.0753 26.5404 17.0249C28.209 16.774 29.328 14.8784 28.9975 12.7916C28.9284 12.1849 28.7249 11.6013 28.4018 11.0833C28.0787 10.5652 27.6442 10.1257 27.1298 9.79682V9.79682Z"
                    fill="#F2D79A"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M15.5265 8.69569C17.195 8.44692 18.2952 6.55231 17.9838 4.46395C17.6724 2.37559 16.0674 0.884301 14.3989 1.13307C12.7304 1.38183 11.6302 3.27645 11.9416 5.36481C12.2529 7.45317 13.8579 8.94445 15.5265 8.69569Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.042 4.85498L29.0135 12.78"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8189 6.53564L28.9895 14.3173"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.2017 7.69824L28.464 15.6869"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3535 8.66602L27.3608 16.5631"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.0869 18.7812C25.6723 19.1795 27.3489 21.1428 27.5241 23.1261C27.6994 25.1093 27.2334 27.9049 25.1904 28.789C23.1475 29.6731 20.2443 30.7006 17.1938 27.7377C16.4536 27.0611 15.7764 26.3187 15.1707 25.5195C15.569 25.5195 19.1531 22.8274 19.1531 22.8274C19.1531 22.8274 20.8178 24.8186 21.9408 24.5279C23.0638 24.2371 22.3789 22.4769 21.3315 21.2503C22.1837 20.2786 25.0869 18.7812 25.0869 18.7812Z"
                    fill="#F2D79A"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.8745 21.173C24.9545 20.5495 25.5581 19.5731 25.2227 18.9921C24.8873 18.4112 23.7398 18.4457 22.6598 19.0692C21.5799 19.6928 20.9763 20.6692 21.3117 21.2501C21.6471 21.8311 22.7945 21.7966 23.8745 21.173Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.7917 25.2345C18.925 24.5801 19.5718 23.5788 19.2364 22.9978C18.901 22.4169 17.7104 22.4763 16.577 23.1307C15.4437 23.785 14.7969 24.7864 15.1323 25.3673C15.4677 25.9483 16.6583 25.8888 17.7917 25.2345Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11299">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.194336)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMPantryActive;

MMPantryActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMPantryActive.defaultProps = {
    className: null,
    width: 28,
};
